import { render, staticRenderFns } from "./HotelExcelIceAktar.vue?vue&type=template&id=954a0da8&scoped=true"
import script from "./HotelExcelIceAktar.vue?vue&type=script&lang=js"
export * from "./HotelExcelIceAktar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "954a0da8",
  null
  
)

export default component.exports